import React from 'react'
import { Box, Modal, Text } from '@maui/elements'
import { PageLoading } from '../common/PageLoading'
import { VulnerabilityDetails } from '../details/VulnerabilityDetails'
import { DetailsSection } from '../details/DetailsSection'
import { useVulnerabilityQuery } from '@nautilusjs/mati-apis'
import { ViewObjectLinks } from './ViewObjectLinks'

function VulnerabilityModal({ useQuery, ...modalProps }) {
  const {
    id,
    name
  } = modalProps
  const { data: cveData, error, isLoading } = useVulnerabilityQuery(id, { refetchOnWindowFocus: false })

  return (
    <Modal {...modalProps} ariaHideApp={false}>
      <Modal.Header onClose={modalProps.onClose}>
        <Modal.TitleIcon name='shield-alert' />
        <Modal.Title>
          { name }
          {cveData?.mve_id ? <Text color='colorTextDeemphasis' fontWeight='700' fontSize='10px'>{cveData.mve_id}</Text> : null}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <DetailsSection
          title="Vulnerability Summary"
          headerSlot={cveData && <ViewObjectLinks path={`/vulnerabilities/${cveData.id}`} />}
          p={0}
        >
          {cveData === null && (
            <Box height={250} display="flex" alignItems="center" justifyContent="center">
              <Text>No data available</Text>
            </Box>
          )}

          {isLoading
            ? <PageLoading/>
            : <VulnerabilityDetails id={id} cveData={cveData} />
          }
          {error && (
            <Box height={250}>
              Error loading vulnerability
            </Box>
          )}
        </DetailsSection>
      </Modal.Body>
    </Modal>
  )
}

export default VulnerabilityModal
